import React from 'react';
import { useReviewProgress } from '../../../contexts/predictions.hooks';

/** "x of y reviewed", what is left, and a bar: the detections of the confidence window, decided or not. */
export function ReviewProgress() {
  const { reviewed, total } = useReviewProgress();

  if (total === 0) {
    return null;
  }

  return (
    <div
      className="flex shrink-0 flex-col gap-1.5 border-b border-dl-border px-3.5 pb-3 pt-2.5 mt-1"
      data-testid="review-progress"
    >
      <div className="flex justify-between text-xs">
        <span className="font-semibold text-dl-text">
          {reviewed} of {total} reviewed
        </span>
        <span className="text-dl-muted">{total - reviewed} pending</span>
      </div>
      <div
        role="progressbar"
        aria-label="Detections reviewed"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={reviewed}
        className="h-1 overflow-hidden rounded-sm bg-dl-border"
      >
        <div
          className="h-1 bg-[#B455A8] transition-[width] duration-200 ease-in-out"
          style={{ width: `${(reviewed / total) * 100}%` }}
        />
      </div>
    </div>
  );
}
